module.exports = __webpack_public_path__ + "static/img/ag_9.4ecbd05.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント2/ag_9.png
// module id = 885
// module chunks = 1